import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdminProductMetricsDTO, AdminProductSearchDTO, ProductDTO, ResponseList, ProductAuditLog } from './product';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    private readonly _baseUrl = `admin/product`;

    constructor(private _httpClient: HttpClient) { }

    /**
     * Search products
     * @param search 
     */
    search(search: AdminProductSearchDTO): Observable<ResponseList<AdminProductMetricsDTO>> {
        const params: any = {};
        Object.entries(search).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params[key] = value;
            }
        });
        return this._httpClient.get<ResponseList<AdminProductMetricsDTO>>(`${this._baseUrl}/search`, {
            params
        });
    }

    /**
     * Get product details
     * @param id 
     */
    getById(id: string): Observable<ProductDTO> {
        return this._httpClient.get<ProductDTO>(`${this._baseUrl}/${id}`);
    }

    /**
     * Update product status
     * @param id 
     * @param status 
     */
    updateStatus(id: string, status: 'ACTIVE' | 'BLOCKED' | 'PAUSED' | 'SOLD'): Observable<any> {
        return this._httpClient.patch(`${this._baseUrl}/${id}/status`, null, {
            params: { status }
        });
    }

    /**
     * Get product audit logs
     * @param id
     */
    getAuditLogs(id: string): Observable<ProductAuditLog[]> {
        return this._httpClient.get<ResponseList<ProductAuditLog>>(`admin/audit/search?entityType=PRODUCT&entityId=${id}&size=100`).pipe(
            map(response => response.list || [])
        );
    }
}
